// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"4":"2eb49fa7","12":"b8b9be6c","100":"1e177e9f","195":"7fcfa0f2","458":"8dfca0d9","473":"10e0b930","511":"d5cd03bd","513":"9272c8db","777":"802fd059","787":"58e47f96","856":"189fc2ac"}[chunkId] + ".chunk.js";
};